// extracted by mini-css-extract-plugin
export default {"filesInput":"InputFile_filesInput__DlO1b","chosenFiles":"InputFile_chosenFiles__ZJFGU"};